__webpack_require__.p = "https://uat.insight.affinity.io/";